module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.878ad715.woff";